import { render, staticRenderFns } from "./manage-product-field.vue?vue&type=template&id=75d96135&scoped=true&"
import script from "./manage-product-field.vue?vue&type=script&lang=js&"
export * from "./manage-product-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d96135",
  null
  
)

export default component.exports